// extracted by mini-css-extract-plugin
export var dark = "stats-module--dark--1c75f";
export var grid = "stats-module--grid--efb22";
export var light = "stats-module--light--512a5";
export var stats = "stats-module--stats--4df4c";
export var statsDisclaimer = "stats-module--statsDisclaimer--807ce";
export var statsHeadline = "stats-module--statsHeadline--3b553";